import { LS_TOKEN_KEY } from "constants/constants";
import { io as Client, Socket } from "socket.io-client";

const BROWSER_NAMESPACE = "/socket/browser";

export const buildSocket = (codeOnline: string): Socket => {
    return Client(
        `${window.env.REACT_APP_ONLINE_API_BASE_URL}${BROWSER_NAMESPACE}`,
        {
            transports: ["websocket"],
            reconnectionAttempts: 1,
            forceNew: true,
            query: {
                codeOnline,
            },
            withCredentials: true,
            auth: (cb) => {
                cb({
                    token: `Bearer ${localStorage.getItem(LS_TOKEN_KEY)}`,
                });
            },
        },
    );
};
